// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body.NotFoundPage_noScroll__suwco {
  overflow: hidden; /* Prevent scrolling */
  height: 100vh;
}

.NotFoundPage_notFoundWrapper__P5JGU {
  display: flex;
  flex-direction: column; /* Stack the content vertically */
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: var(--color-background);
  color: var(--color-text);
  text-align: center;
  overflow: hidden; /* Prevent scrolling */
  position: relative; /* Ensure proper layering */
}

.NotFoundPage_content__PonFG {
  position: relative;
  z-index: 2; /* Ensure content is above the canvas */
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 600px;
  padding: var(--space-md);
  border-radius: var(--space-xs);
  background: rgba(0, 0, 0, 0.8);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.NotFoundPage_title__IoSva {
  font-size: 3.2rem; /* Adjust font size to match article page proportions */
  font-weight: 400;
  margin-top: var(--space-md); /* Add margin to separate from the image */
  margin-bottom: var(--space-sm);
}

.NotFoundPage_image__YiLwW {
  max-width: 50%; /* Adjust width of the image */
  border-radius: 10px;
  margin-top: var(--space-md);
  margin-bottom: var(--space-md); /* Add margin below the image */
}

.NotFoundPage_subtitle__uvpxT {
  font-size: var(--font-size-medium);
  margin-bottom: var(--space-md);
}

.NotFoundPage_homeLink__0PycX {
  display: inline-block;
  padding: var(--space-xs) var(--space-sm);
  background-color: var(--color-text);
  color: var(--color-background);
  text-decoration: none;
  font-size: var(--font-size-small);
  border-radius: 25px;
  border: none;
  transition: transform 0.3s ease, background-color 0.3s ease;
}

.NotFoundPage_homeLink__0PycX:hover {
  transform: scale(1.05);
  background-color: var(--color-text-subtle);
}
`, "",{"version":3,"sources":["webpack://./src/components/NotFoundPage.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB,EAAE,sBAAsB;EACxC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB,EAAE,iCAAiC;EACzD,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,yCAAyC;EACzC,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB,EAAE,sBAAsB;EACxC,kBAAkB,EAAE,2BAA2B;AACjD;;AAEA;EACE,kBAAkB;EAClB,UAAU,EAAE,uCAAuC;EACnD,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,8BAA8B;EAC9B,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB,EAAE,uDAAuD;EAC1E,gBAAgB;EAChB,2BAA2B,EAAE,0CAA0C;EACvE,8BAA8B;AAChC;;AAEA;EACE,cAAc,EAAE,8BAA8B;EAC9C,mBAAmB;EACnB,2BAA2B;EAC3B,8BAA8B,EAAE,+BAA+B;AACjE;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,wCAAwC;EACxC,mCAAmC;EACnC,8BAA8B;EAC9B,qBAAqB;EACrB,iCAAiC;EACjC,mBAAmB;EACnB,YAAY;EACZ,2DAA2D;AAC7D;;AAEA;EACE,sBAAsB;EACtB,0CAA0C;AAC5C","sourcesContent":["body.noScroll {\n  overflow: hidden; /* Prevent scrolling */\n  height: 100vh;\n}\n\n.notFoundWrapper {\n  display: flex;\n  flex-direction: column; /* Stack the content vertically */\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  background-color: var(--color-background);\n  color: var(--color-text);\n  text-align: center;\n  overflow: hidden; /* Prevent scrolling */\n  position: relative; /* Ensure proper layering */\n}\n\n.content {\n  position: relative;\n  z-index: 2; /* Ensure content is above the canvas */\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  max-width: 600px;\n  padding: var(--space-md);\n  border-radius: var(--space-xs);\n  background: rgba(0, 0, 0, 0.8);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.title {\n  font-size: 3.2rem; /* Adjust font size to match article page proportions */\n  font-weight: 400;\n  margin-top: var(--space-md); /* Add margin to separate from the image */\n  margin-bottom: var(--space-sm);\n}\n\n.image {\n  max-width: 50%; /* Adjust width of the image */\n  border-radius: 10px;\n  margin-top: var(--space-md);\n  margin-bottom: var(--space-md); /* Add margin below the image */\n}\n\n.subtitle {\n  font-size: var(--font-size-medium);\n  margin-bottom: var(--space-md);\n}\n\n.homeLink {\n  display: inline-block;\n  padding: var(--space-xs) var(--space-sm);\n  background-color: var(--color-text);\n  color: var(--color-background);\n  text-decoration: none;\n  font-size: var(--font-size-small);\n  border-radius: 25px;\n  border: none;\n  transition: transform 0.3s ease, background-color 0.3s ease;\n}\n\n.homeLink:hover {\n  transform: scale(1.05);\n  background-color: var(--color-text-subtle);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"noScroll": `NotFoundPage_noScroll__suwco`,
	"notFoundWrapper": `NotFoundPage_notFoundWrapper__P5JGU`,
	"content": `NotFoundPage_content__PonFG`,
	"title": `NotFoundPage_title__IoSva`,
	"image": `NotFoundPage_image__YiLwW`,
	"subtitle": `NotFoundPage_subtitle__uvpxT`,
	"homeLink": `NotFoundPage_homeLink__0PycX`
};
export default ___CSS_LOADER_EXPORT___;
